import { supabase } from "@/integrations/supabase/client";
import type { ProviderId, BankAccount } from "./types";

export interface CreatePaymentIntentRequest {
  provider: ProviderId;
  order_id: string;
  amount: number;
  currency: "DOP";
  idempotency_key: string;
}

export interface CreatePaymentIntentResponse {
  transaction_id: string;
  provider_ref: string | null;
  status: string;
  redirect_url?: string;
  instructions?: {
    title: string;
    steps: string[];
    bankAccounts?: BankAccount[];
    reference: string;
  };
}

export async function invokeCreatePaymentIntent(
  body: CreatePaymentIntentRequest,
): Promise<CreatePaymentIntentResponse> {
  const { data, error } = await supabase.functions.invoke<CreatePaymentIntentResponse>(
    "create-payment-intent",
    { body },
  );
  if (error) throw error;
  if (!data) throw new Error("create-payment-intent: empty response");
  return data;
}

/**
 * Stable idempotency key per (orderId, attempt). Re-submitting the same
 * checkout never creates a duplicate transaction row.
 */
export function makeIdempotencyKey(orderId: string, salt = ""): string {
  return `${orderId}:${salt || crypto.randomUUID()}`;
}